import React from "react";
import { Card, CardBody } from "reactstrap";
import Theme from "../../theme";

import { useAtom } from "jotai";
import { mobileAtom } from "../../AtomStore/store";

export const InnerHOC = ({
  heading = "Heading",
  backgroundColor = Theme.colorPrimary,
  history,
  children,
}) => {
  return (
    <Card className="border-0 shadow  card-timeline">
      <CardBody>{children}</CardBody>
    </Card>
  );
};
